export const BASE_PRODUCT_STATUS = {
  ALL: "",
  ACTIVE: "active",
  INACTIVE: "inactive",
  DELETED: "deleted",
};

export const baseProductStatusLabels = {
  [BASE_PRODUCT_STATUS.ALL]: "All",
  [BASE_PRODUCT_STATUS.ACTIVE]: "Active",
  [BASE_PRODUCT_STATUS.INACTIVE]: "Deactivated",
  [BASE_PRODUCT_STATUS.DELETED]: "Erase!",
};

export const baseProductStatusBgColors = {
  [BASE_PRODUCT_STATUS.ACTIVE]: "linear-gradient(90deg, #19C38B, #088D96)",
  [BASE_PRODUCT_STATUS.INACTIVE]: "linear-gradient(90deg, #797979, #595959)",
  [BASE_PRODUCT_STATUS.DELETED]: "linear-gradient(90deg, #FF1111, #9B1C00)",

};

export const statusBaseProductFilters = () => {
  return {
    [BASE_PRODUCT_STATUS.ALL]: "All",
    [BASE_PRODUCT_STATUS.ACTIVE]: "Active",
    [BASE_PRODUCT_STATUS.INACTIVE]: "Deactivated",
    [BASE_PRODUCT_STATUS.DELETED]: "Erase!",
  };
};